import React from "react"
import { connect } from "react-redux"

function withToken(Wrapped) {
  return connect((store) => ({ token: store.auth.user.token }))((props) => {
    return <Wrapped {...props} token={props.token}/>
  })
}

export default withToken